'use client';

import ChevronButton from 'src/components/Buttons/ChevronButton';

interface ExpandCellProps {
	orderId: number;
	isExpanded: boolean;
	onToggleExpand: (orderId: number) => void;
}

export function ExpandCell({
	orderId,
	isExpanded,
	onToggleExpand,
}: ExpandCellProps) {
	return (
		<div className="flex h-full items-center justify-center">
			<ChevronButton
				direction={isExpanded ? 'up' : 'down'}
				aria-label={isExpanded ? 'Collapse row' : 'Expand row'}
				variant="tertiary"
				onClick={(e) => {
					e.stopPropagation();
					onToggleExpand(orderId);
				}}
			/>
		</div>
	);
}
